import React, { memo, SVGProps } from 'react'

export const Camera = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M19.2829 5H4.7171C3.4949 5 2.5 5.98059 2.5 7.1852V16.8148C2.5 18.0194 3.4949 19 4.7171 19H19.2829C20.5051 19 21.5 18.0194 21.5 16.8148V7.1852C21.5 5.98059 20.5051 5 19.2829 5ZM20.0468 16.8148C20.0468 17.2298 19.704 17.5677 19.2829 17.5677H4.7171C4.29604 17.5677 3.95323 17.2298 3.95323 16.8148V7.1852C3.95323 6.7702 4.29604 6.43232 4.7171 6.43232H19.2829C19.704 6.43232 20.0468 6.7702 20.0468 7.1852V16.8148Z"
      fill="currentColor"
    />
    <path
      d="M10.884 7.48269C8.35762 7.48269 6.30075 9.50997 6.30075 12C6.30075 14.49 8.35762 16.5173 10.884 16.5173C13.4104 16.5173 15.4672 14.49 15.4672 12C15.4672 9.50997 13.4104 7.48269 10.884 7.48269ZM10.884 15.085C9.15876 15.085 7.75397 13.7004 7.75397 12C7.75397 10.2996 9.15876 8.91501 10.884 8.91501C12.6092 8.91501 14.014 10.2996 14.014 12C14.014 13.7004 12.6092 15.085 10.884 15.085Z"
      fill="currentColor"
    />
    <path
      d="M17.5465 7.48269C16.4323 7.48269 15.5269 8.37513 15.5269 9.47324C15.5269 10.5714 16.4323 11.4638 17.5465 11.4638C18.6606 11.4638 19.5661 10.5714 19.5661 9.47324C19.5661 8.37513 18.6606 7.48269 17.5465 7.48269ZM17.5465 10.0278C17.2372 10.0278 16.9838 9.77807 16.9838 9.46957C16.9838 9.16107 17.2372 8.91501 17.5465 8.91501C17.8558 8.91501 18.1129 9.16474 18.1129 9.46957C18.1129 9.7744 17.8595 10.0278 17.5465 10.0278Z"
      fill="currentColor"
    />
  </svg>
))
